import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section-padding" }
const _hoisted_2 = { class: "text-just" }
const _hoisted_3 = { class: "d-none d-md-flex" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "column second" }
const _hoisted_6 = { class: "d-none d-md-flex" }
const _hoisted_7 = { class: "column" }
const _hoisted_8 = { class: "d-flex flex-column d-md-none" }
const _hoisted_9 = { class: "text-just" }

import LogoImageBackground from "@/components/LogoImageBackground.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'StudiesView',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('sectionStudies.studies')), 1),
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t('sectionStudies.studiesText')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('sectionStudies.bachelorsDegree')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.university')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.mainSubjects')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.bachelorsMainSubjects')), 1),
          _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('sectionStudies.mastersDegree')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.mastersDegreeText')), 1),
          _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.additionalTrainings')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.addTrain1')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.addTrain2')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.currentStudies')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.currStudText')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('sectionStudies.bachelorsDegree')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.university')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.mainSubjects')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.bachelorsMainSubjects')), 1),
          _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('sectionStudies.mastersDegree')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.mastersDegreeText')), 1),
          _cache[3] || (_cache[3] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.additionalTrainings')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.addTrain1')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.addTrain2')), 1),
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('sectionStudies.currentStudies')), 1),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('sectionStudies.currStudText')), 1)
        ])
      ])
    ]),
    _createVNode(LogoImageBackground)
  ], 64))
}
}

})